export function Header() {
	return (
		<div className="text-center">
			<h1>star wars</h1>
			<span className="uppercase font-bold text-base">characters</span>
		</div>
	)
}
